"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSharedEntity = void 0;
const euclid_1 = require("@reality/euclid");
const CSEntity_1 = require("./CSEntity");
// TODO - State management must be through immutable object transforms. None of this overlapping shit.
/**
 * Represents a client-side entity that has state shared with the server. RegionEntities and ClientEntities
 * are derived from this class.
 */
class CSSharedEntity extends CSEntity_1.CSEntity {
    constructor(manifest, instanceID, initialLocalStore, universalState, sharedStore, messages, animationManager) {
        super(manifest, instanceID, initialLocalStore, animationManager);
        this.handleStateUpdate = (payload) => {
            const oldState = this._entityState;
            this._entityState = Object.assign({}, payload.entityState);
            if (!euclid_1.CoordinateUtils.isEqual(oldState.position, this._entityState.position)) {
                this.emit("move", {
                    oldPos: oldState.position,
                    newPos: this._entityState.position,
                });
            }
            if (payload.animation) {
                this._animationManager.queueAnimation(this, payload.animation);
            }
        };
        this._entityState = universalState;
        this._sharedStore = sharedStore;
        this._manifest = manifest;
        this._messages = messages;
        //
        this._messages.StateUpdate.handleSome(this.handleStateUpdate, (payload) => this._instanceID === payload.instanceId);
    }
    setState(key, value, animation) {
        // TODO - On the client, this is illegal. We should instead dispatch a message requesting a state change from the server.
        const oldState = this._entityState;
        this._entityState = Object.assign(Object.assign({}, this._entityState), { [key]: value });
        this._messages.RequestStateChange.send({
            instanceId: this._instanceID,
            requestedState: Object.assign(Object.assign({}, this._entityState), { [key]: value }),
            requestedAnimation: animation,
        });
        // this is a hack we shouldn't need this in handle state and here
        if (key === "position") {
            if (!euclid_1.CoordinateUtils.isEqual(oldState.position, this._entityState.position)) {
                this.emit("move", {
                    oldPos: oldState.position,
                    newPos: this._entityState.position,
                });
            }
        }
    }
    setWholeState(newState, animation) {
        const beforePos = this._entityState.position;
        const afterPos = newState.position;
        //
        if (!euclid_1.CoordinateUtils.isEqual(beforePos, afterPos)) {
            // FIXME hack
            this.emit("move", {
                oldPos: beforePos,
                newPos: afterPos,
            });
        }
        //
        this._entityState = newState;
        this._messages.RequestStateChange.send({
            instanceId: this._instanceID,
            requestedState: newState,
            requestedAnimation: animation,
        });
    }
    // setShared = <Key extends keyof SharedStore>(key: Key, value: SharedStore[Key]): void => {
    //   // TODO - On the client, this is illegal. We should instead dispatch a message requesting a state change from the server.
    //   // this._sharedStore = {...this._sharedStore, [key]: value};
    //   this._requestStoreChangeMessage.send({
    //     instanceId: this._instanceID,
    //     storeKey: key as string, // TODO fuck
    //     storeValue: value,
    //   });
    // };
    get sharedStore() {
        return this._sharedStore;
    }
    get manifest() {
        return this._manifest;
    }
}
exports.CSSharedEntity = CSSharedEntity;
//# sourceMappingURL=CSSharedEntity.js.map